import styled from "styled-components";
import {OptInLogoDefaultBox} from "./opt-in-logo.default.box";

export const OptInLogoCasino777Box = styled(OptInLogoDefaultBox)`  
    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        width: 10rem;  
        height: 8rem;
    }
    
    width: 17rem;  
    height: 10rem;

    margin-top: 20px;
    margin-bottom: -8px;

    background-repeat: no-repeat, no-repeat;
`;
